/**
 * src/part-compile/containers/CheckoutForm.jsx
 */

import axios from "axios";

export default function CheckoutLayout() {
    if (!window.__Variables__) {
        return;
    }

    const domCheckout = document.querySelector(".checkout-layout#Checkout");
    const domSuccess = document.querySelector(".checkout-layout#Success");
    const domCancel = document.querySelector(".checkout-layout#Cancel");
    const domIncomplete = document.querySelector(".checkout-layout#Incomplete");

    (function __constructor() {
        const action = location.pathname.split("/").filter(v => !!v)[1] || "checkout";

        if (domCheckout && domSuccess && domCancel) {
            showLayout(domCheckout, "checkout", Checkout);
            showLayout(domSuccess, "success", Success);
            showLayout(domCancel, "cancel", Cancel);
        } else if (domIncomplete) {
            showLayout(domIncomplete, -1, Incomplete);
        }

        function showLayout(dom, _action, handle) {
            const is = _action === action || _action === -1;

            is && handle?.();
            dom.style[is ? "removeProperty" : "setProperty"]("display", "none !important");
        }
    })();

    function Checkout() {
        const domCheckoutForm = domCheckout.querySelector(".checkout-form");

        if (!domCheckoutForm) {
            return;
        }

        const IgnoreFields = ["addressline2"];

        // Checkout
        let payDetails = getPayDetails();

        // DOM's
        const domOptions = domCheckoutForm.querySelector(".options");
        const domOptionsItem = domOptions.querySelector(".options-item");
        const domSubmitButtons = domCheckoutForm.querySelectorAll("button[type=submit]");

        // Options
        if (Object.keys(window.__CheckoutOptions__).length === 0) {
            if (domOptions.parentElement) {
                domOptions.parentElement.removeChild(domOptions);
            }
        } else {
            if (domOptionsItem.parentElement) {
                domOptionsItem.parentElement.removeChild(domOptionsItem);
            }

            domOptionsItem.removeAttribute("style");

            for (const key in window.__CheckoutOptions__) {
                const domItem = domOptionsItem.cloneNode(true);
                domItem.querySelector(".option-item-type").textContent = key;
                domItem.querySelector(".option-item-value").textContent = window.__CheckoutOptions__[key];
                domOptions.appendChild(domItem);
            }
        }

        // form change
        domCheckoutForm.addEventListener("submit", onSubmit);
        domCheckoutForm.addEventListener("change", onChange);
        domCheckoutForm.addEventListener("input", onChange);

        // init
        eachElement(domElement => {
            if (payDetails?.[domElement.name] !== undefined) {
                domElement.value = payDetails[domElement.name];
            }
        });

        // emulate change
        domCheckoutForm.dispatchEvent(new Event("change"));

        // Methods
        async function onSubmit(event) {
            event.preventDefault();
            onUpdate();

            // console.log({ ...payDetails, options: window.__CheckoutOptions__ });

            setDisabled(true);
            setErrors([]);

            const response =
                (
                    await axios.post(__URLCheckoutCreate__, {
                        ...payDetails,
                        options: { ...window.__CheckoutOptions__ },
                    })
                )?.data || {};

            const { iid, link, errors } = response;

            if (errors) {
                if (Array.isArray(errors)) {
                    const inputNames = [];
                    for (const error of errors) {
                        if (error?.field) {
                            inputNames.push(error.field);
                        } else {
                            console.warn(error);
                        }
                    }
                    setErrors(inputNames);
                } else {
                    console.warn(errors);
                }
            } else if (link) {
                location = link;
                return;
            } else {
                console.warn("Create:", response);
            }

            setDisabled(false);
        }

        function setDisabled(disabled = true) {
            const mtd = disabled ? "setAttribute" : "removeAttribute";
            for (const domElement of domCheckoutForm.elements) {
                domElement[mtd]("disabled", "");
            }
        }

        function setErrors(errors = ["firstname"]) {
            eachElement(domElement => {
                if (errors.includes(domElement.getAttribute("name"))) {
                    domElement.classList.add("error");
                } else {
                    domElement.classList.remove("error");
                }
            });
        }

        function onChange(event) {
            onUpdate(event.type === "blur");
        }

        function onUpdate(trim = false) {
            let hasEmpty = false;

            eachElement(domElement => {
                const { name, value } = domElement;
                trim && (domElement.value = domElement.value.trim());
                payDetails[name] = value.trim();
                if (!IgnoreFields.includes(name)) {
                    hasEmpty = hasEmpty || !payDetails[name]?.trim();
                }
            });

            setPayDetails(payDetails);

            const disabled = hasEmpty ? "setAttribute" : "removeAttribute";
            for (const domButton of domSubmitButtons) {
                domButton[disabled]("disabled", "");
            }
        }

        function eachElement(handle = domElement => {}) {
            for (const domElement of domCheckoutForm.elements) {
                if (!domElement.name) {
                    continue;
                }

                handle(domElement);
            }
        }

        function getPayDetails() {
            return JSON.parse(localStorage.getItem("pay-details") ?? "{}");
        }

        function setPayDetails(payDetails = {}) {
            localStorage.setItem("pay-details", JSON.stringify(payDetails));
        }
    }

    async function Success() {
        const usp = new URLSearchParams(location.search);
        const iid = usp.get("iid");

        const domSuccessFinalized = domSuccess.querySelector(".checkout-success-finalized");
        const domSuccessWait = domSuccess.querySelector(".checkout-success-wait");
        const domSuccessWaitPayer = domSuccess.querySelector(".checkout-success-wait-payer");
        const domSuccessMessage = domSuccess.querySelector(".checkout-success-message");
        const domBackToProductPage = domSuccess.querySelector(".back-to-product-page");

        const domOrderNumber = domSuccess.querySelectorAll(".order-number");
        for (const dom of domOrderNumber) {
            dom.textContent = iid;
        }

        let response;
        while (true) {
            response = (await axios.post(__URLCheckoutStatus__, { iid }).catch(() => {}))?.data || {};

            if (response?.status === "completed") {
                break;
            }

            domSuccessFinalized.style.setProperty("opacity", "1");
            domSuccessFinalized.style.removeProperty("display");
            domSuccessWaitPayer.style.removeProperty("display");

            if (response?.status) {
                if (response?.status === "approved") {
                    domSuccessWaitPayer.style.setProperty("opacity", "1");
                } else {
                    domSuccessWaitPayer.style.setProperty("opacity", "0");
                    console.log(response?.status);
                }
            } else {
                console.log("?", response);
            }

            // sleep
            await new Promise(r => setTimeout(r, 4000));

            // response = (await axios.post(__URLCheckoutStatus__, { iid }).catch(() => {}))?.data || {};
        }

        domSuccessWait.style.setProperty("display", "none");
        domSuccessMessage.style.removeProperty("display");

        domBackToProductPage.addEventListener("click", () => (location = location.origin));
    }

    function Cancel() {
        const domBackToProductPage = domCancel.querySelector(".back-to-product-page");
        domBackToProductPage.addEventListener("click", () => (location = location.origin));
    }

    function Incomplete() {
        const domBackToProductPage = domIncomplete.querySelector(".back-to-product-page");
        domBackToProductPage.addEventListener("click", () => (location = location.origin));
    }
}
